import {Signal} from "@preact/signals-react";
import {signal} from "@preact/signals-core";
import {IResult} from "../_interfaces/IResult";

export const s_results: Signal<(IResult)[]> = signal([]);
